export const isPlaylist = {
  IS_PLAYLIST: "IS_PLAYLIST",
  IDENTIFYING_ALBUMS: "IDENTIFYING_ALBUMS",
};